/* Produktseiten-Abschnitt rr-lane, ausgelagert am 31.07.2026.
   Grund: die Vorlage sections/rr-lane.liquid lief mit 281.078 Bytes gegen
   Shopifys Grenze von 262.144 Bytes je Vorlage. Assets kennen die Grenze nicht.
   ACHTUNG: in einem Asset verarbeitet Shopify KEIN Liquid. Hier darf niemals eine
   Liquid-Ausgabe oder ein Liquid-Tag stehen — es käme wörtlich beim Browser an.
   Die Wurzel wird deshalb über die Klasse gefunden, nicht über section.id.
   Diese Datei enthält bewusst KEINE geschweiften Doppelklammern, damit eine
   Grep-Kontrolle darauf aussagekräftig bleibt. */
(function(){
  var root = document.querySelector('.rrl2[data-rrl2-lane]');
  if (!root || root.dataset.rrl2Ready) return;

  /* Der Kaufbausatz wandert weiter unten in .product-form-buttons des Themes und
     liegt danach NICHT mehr unter .rrl2. Jede Kapsel, die erst danach läuft und
     `root.querySelector` benutzt, greift damit ins Leere. Am 31.07. am Duplikat
     nachgemessen gab die Wurzelsuche 0 zurück, während das Dokument 1 hatte.

     Am 31.07. um 14:44 kam die teure Fortsetzung davon: die Karten „Ein Werk"
     und „Zwei Werke" schalteten nie um, weil rechnen() sie aus der Wurzel holt.
     Die Kundin sah 19,95 €, im Warenkorb lagen 29,95 €. Beim ersten Mal hatte
     ich nur geprüft, ob eine Kapsel VOR dem Umzug startet — die falsche Frage.
     Entscheidend ist, wann ihr Code LÄUFT: ein Zuhörer wird früh angemeldet und
     feuert spät. Deshalb sucht ab jetzt NICHTS mehr direkt aus der Wurzel.

     `suchen` liefert eine Liste, `eins` das erste Ergebnis oder null. Solange
     der Bausatz noch unter .rrl2 hängt, sind beide identisch mit der alten
     Wurzelsuche — in der örtlichen Vorschau gibt es kein .product-form-buttons,
     dort zieht nichts um: derselbe Code, beide Welten.

     WER HIER ETWAS ANFÜGT: nimm `eins` und `suchen`, niemals die Wurzel direkt.
     Die zwei Zeilen unten sind die einzige erlaubte Ausnahme, sie bauen die
     Sucherei selbst. Gegenprobe:
       grep -c "root\.querySelector" assets__rr-lane.js
       erwartet 4 — zwei Codezeilen hier unten, zwei Erwähnungen in Prosa. */
  var bausatz = root.querySelector('[data-rrl2-buy]');
  function suchen(wahl){
    var treffer = [].slice.call(root.querySelectorAll(wahl));
    if (bausatz && !root.contains(bausatz)) {
      if (bausatz.matches && bausatz.matches(wahl)) treffer.push(bausatz);
      [].push.apply(treffer, [].slice.call(bausatz.querySelectorAll(wahl)));
    }
    return treffer;
  }
  function eins(wahl){ var t = suchen(wahl); return t.length ? t[0] : null; }

  /* Brücke von melde() nach D1, gesetzt in der Messkapsel weiter unten.
     Grund: bis zum 31.07. gingen die aussagekräftigsten Signale — Coverwahl,
     Leistenwahl, Kapitel, Aufklapper — ausschliesslich an Umami, während die
     Abbruchkurve aus D1 gelesen wird. Die Zahlen lagen also in zwei Töpfen,
     und der, in den geschaut wird, war der ärmere.
     `feuern` lebt in der Messkapsel, weil dort die Warteschlange sitzt, die
     Ereignisse bis zum Eintreffen von tracking.js hält. Statt sie ein zweites
     Mal zu bauen, wird die Funktion hier abgelegt. Bleibt null, falls die
     Messkapsel je vorzeitig aussteigt — dann meldet melde() weiter an Umami,
     ohne zu werfen. */
  var nachD1 = null;

  /* DIE ÜBERNAHME LÄUFT ZUERST — seit dem 31.07. bewusst ganz oben.
     Vorher stand sie hinter sieben Kapseln. Das CSS blendet die Theme-Galerie
     und den Theme-Preis UNBEDINGT aus, sobald die Seite rendert; der Ersatz
     wird dagegen erst von hier sichtbar. Wirft irgendeine Kapsel davor, steht
     eine Produktseite OHNE EIN EINZIGES BILD da — kaufbar zwar, aber blind.
     Ganz vorn kann keine andere Kapsel sie mehr verhindern.
     Was das NICHT abdeckt: lädt das Asset gar nicht, hilft auch das nichts.
     Dagegen bräuchte es einen Notschalter in der Vorlage selbst.

     Was sie tut: den eigenen Kaufbausatz in den Kaufbereich des Themes schieben.
     Serverseitig gerendert, damit nichts aufblitzt; nur Links, kein Absenden. */
  (function(){
    /* Derselbe Knoten wie oben — keine zweite Suche und keine Verdeckung der
       äußeren Kennung, sonst liest sich später schwer, welche gemeint ist. */
    var ziel = document.querySelector('.product-form-buttons');
    if (!bausatz || !ziel || ziel.dataset.rrlBefüllt) return;
    ziel.dataset.rrlBefüllt = '1';
    ziel.appendChild(bausatz);
    bausatz.hidden = false;
    /* Erst jetzt dürfen die Theme-Knöpfe verschwinden. Fällt das JS aus,
       bleibt der Theme-Knopf sichtbar und die Seite bleibt kaufbar. */
    if (ziel.contains(bausatz)) ziel.classList.add('rrl2-ersetzt');

    /* Der Titel wandert an IM8s Stelle: unter die Bilderreihe, über den Fließtext.
       VERSCHOBEN, nicht verdoppelt — die Seite behält genau eine H1, mit demselben
       Wortlaut wie im Laden. Läuft das Skript nicht, steht der Titel weiter oben,
       wo das Theme ihn rendert: nichts geht verloren. */
    var platz = bausatz.querySelector('[data-rrl2-titel]');
    /* Erst im Produktbereich suchen, dann erst im ganzen Dokument. `h1` allein
       nimmt die ERSTE Überschrift der Seite — heute der Produkttitel, aber ein
       künftiges Theme-Update mit einer früheren h1 (Ankündigungsband, Kopfzeile)
       würde die falsche in den Kaufbereich hängen, und zwar lautlos. */
    var h1 = document.querySelector('.product-information h1') || document.querySelector('h1');
    if (platz && h1 && !platz.contains(h1) && !h1.closest('[data-rrl2-buy]')) {
      platz.appendChild(h1);
    }
  })();

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function gesehen(schlüssel){
    try {
      if (sessionStorage.getItem(schlüssel)) return true;
      sessionStorage.setItem(schlüssel, '1');
      return false;
    } catch (e) { return false; }   /* privater Modus: dann halt jedes Mal */
  }

  /* ── Messung ──────────────────────────────────────────────────────────────
     Bis heute war diese Seite blind: tracking.js bindet Klicks nur an
     ".cta-btn, [data-rr=cta]", unsere Knöpfe heißen aber .rrl2-cta,
     .rrl2-btn und [data-rrl2-cart]. In zehn Tagen: 493 Aufrufe, 0 gemessene
     Klicks. Und scroll_25/50/75 ist auf einer Seite mit neun Blöcken zu grob,
     um einen Abbruch zu verorten.

     Steht bewusst GANZ OBEN im Skript: weiter unten sitzen früh zurückkehrende
     Prüfungen (etwa auf den Lightbox-Dialog), hinter denen die Messung bei
     ungewöhnlichem Markup stillschweigend nie liefe.

     Hier wird nur gelesen und gemeldet — keine Zeile ändert das Verhalten. */
  (function(){
    var warteschlange = [], versuche = 0;
    function feuern(typ, meta){
      if (window.RR && RR.fire) { try { RR.fire(typ, meta); } catch (e) {} return; }
      if (warteschlange.length < 40) warteschlange.push([typ, meta]);
    }
    nachD1 = feuern;   /* Brücke setzen, siehe Erklärung oben am Modulkopf. */
    /* tracking.js lädt mit defer, dieses Skript läuft früher. Also warten,
       bis RR da ist, dann das Gesammelte nachreichen. Nach 10 s aufgeben. */
    (function abfluss(){
      if (window.RR && RR.fire) {
        warteschlange.splice(0).forEach(function(e){
          try { RR.fire(e[0], e[1]); } catch (x) {}
        });
        return;
      }
      if (++versuche > 40) return;
      setTimeout(abfluss, 250);
    })();

    var innen = eins('.rrl2-in');
    if (!innen) return;
    var blöcke = [].slice.call(innen.children);
    var bahn = root.dataset.rrl2Lane || '';

    /* Name eines Blocks kommt aus der Augenbraue, die ohnehin dasteht
       ("Blick ins Buch" -> blick-ins-buch). Kein zusätzliches Markup. */
    blöcke.forEach(function(el, i){
      if (el.classList.contains('rrl2-buy')) { el.dataset.rrl2Ab = 'kaufleiste'; return; }
      /* Ein Block hat keine Augenbraue (die Garantie). Der fällt auf seine
         Überschrift zurück, damit er nicht als "block-6" im Bericht steht. */
      var quelle = el.querySelector('.rrl2-lbl') || el.querySelector('h2, h3');
      var t = (quelle ? quelle.textContent : '')
        .toLowerCase()
        .replace(/[ä]/g,'ae').replace(/[ö]/g,'oe')
        .replace(/[ü]/g,'ue').replace(/[ß]/g,'ss')
        .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')
        .slice(0, 24).replace(/-+$/,'');
      el.dataset.rrl2Ab = t || ('block-' + i);
    });

    /* Abschnittssicht. Schwelle 0 mit unterem Rand statt 0.5 — ein Abschnitt,
       der höher ist als der Bildschirm, erreicht nie 50 % Sichtbarkeit und
       würde auf dem Telefon nie melden. */
    if ('IntersectionObserver' in window) {
      var beob = new IntersectionObserver(function(einträge){
        einträge.forEach(function(e){
          /* Auch melden, wenn der Abschnitt zwischen zwei Rückmeldungen
             komplett nach oben durchgerauscht ist. Sonst zählt schnelles
             Wischen die unteren Abschnitte kleiner, als sie gesehen wurden —
             am 29.07. im Test reproduziert: die letzten zwei fehlten. */
          if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
          beob.unobserve(e.target);
          feuern('sicht_' + e.target.dataset.rrl2Ab);
        });
      }, { threshold: 0, rootMargin: '0px 0px -200px 0px' });
      blöcke.forEach(function(el){
        if (!el.classList.contains('rrl2-buy')) beob.observe(el);
      });
    }

    function abschnittVon(el){
      /* Die klebende Kaufleiste wird von der Kaufknopf-Logik aus root heraus in
         Shopifys eigenen Formularblock verschoben (.rrl2-ersetzt). Sie liegt
         also gar nicht mehr unter .rrl2-in — am 29.07. an der echten Seite
         nachgesehen. Deshalb zuerst auf sie prüfen, sonst käme der oberste
         Kaufknopf als "unbekannt" zurück. */
      /* Die Klebeleiste ZUERST, obwohl sie im Kaufbereich liegt. Sonst käme ihr
         Knopf als "kaufleiste" zurück — gleich benannt wie der obere breite
         Knopf, und die Frage „oben oder unten gekauft?" bliebe unbeantwortet,
         obwohl beide Klicks jetzt ankommen. */
      if (el.closest('.rrw-leiste')) return 'klebeleiste';
      if (el.closest('.rrl2-buy')) return 'kaufleiste';
      var b = el;
      while (b && b.parentNode !== innen) b = b.parentNode;
      return (b && b.dataset && b.dataset.rrl2Ab) || 'unbekannt';
    }

    /* Kaufklicks mit Position. Beantwortet endlich, ob oben aus der klebenden
       Leiste, unten aus der Staffel oder aus dem Schluss gekauft wird.
       Hängt an document, nicht an root — aus demselben Grund: die Leiste
       sitzt ausserhalb. */
    document.addEventListener('click', function(e){
      if (!e.target.closest) return;
      /* [data-rrl2-leiste-kauf] seit dem 31.07. dabei. Die Klebeleiste steht seit
         heute DAUERHAFT und ist damit womöglich der meistgeklickte Kaufweg — ihr
         Knopf heisst .rrw-leiste__k und traf keine der vier bisherigen Kennungen.
         Kein abgerissener Alt-Kanal, sondern ein nie angeschlossener neuer. */
      var a = e.target.closest('.rrl2-cta, .rrl2-btn, [data-rrl2-cart], .rrl2-ppl, [data-rrl2-leiste-kauf]');
      if (!a) return;
      var preis = eins('[data-rrl2-price]');
      var stufe = eins('[data-rrl2-meta]');
      feuern('cta_click', {
        pos:   abschnittVon(a),
        lane:  bahn,
        preis: preis ? preis.textContent.trim() : '',
        werke: stufe ? stufe.textContent.trim() : '',
        ziel:  (a.getAttribute('href') || '').slice(0, 120)
      });
    });

    /* Werden die zwei gebauten Sachen überhaupt angefasst? Je einmal pro
       Seitenaufruf, damit ein Dauerzieher die Zahl nicht aufbläst.
       Der Lauscher hängt an den Schiebern selbst, nicht an der ganzen Bahn —
       sonst liefe bei jeder Fingerbewegung irgendwo auf der Seite ein
       closest() durch den Baum, den ganzen Besuch lang. */
    var schieber = [].slice.call(suchen('.rrl2-ba'));
    function baMelden(){
      /* is-zieht setzt der Treiber selbst, sobald er die Geste als waagerecht
         gedeutet hat — genau dann ist es ein echtes Ziehen, kein Scrollen. */
      if (!this.classList.contains('is-zieht')) return;
      schieber.forEach(function(s){ s.removeEventListener('pointermove', baMelden); });
      feuern('ba_zieht', { lane: bahn });
    }
    schieber.forEach(function(s){ s.addEventListener('pointermove', baMelden); });

    /* An document, nicht an root — wie der cta_click-Lauscher eine Kapsel weiter
       oben, und aus demselben Grund: das Galeriebild liegt nach dem Umzug im
       Formularblock des Themes und damit ausserhalb von root.
       Warum das schlimmer war als ein toter Zähler: je Bahn bleiben ZWEI weitere
       [data-rrl2-zoom]-Figuren unter root (.rrl2-zeig__b, .rrw-bnd__c). Die Reihe
       brach also nicht ein, sie mass still etwas anderes — und die Zoom-Hand zeigt
       ausgerechnet auf die Galerie, deren Öffnen nicht mehr gezählt wurde. */
    var zoomGemeldet = false;
    document.addEventListener('click', function(e){
      if (zoomGemeldet || !e.target.closest) return;
      if (!e.target.closest('[data-rrl2-zoom]')) return;
      zoomGemeldet = true;
      feuern('zoom_auf', { lane: bahn });
    });
  })();

  /* Die Hand über dem Rezeptbild lief bisher beim Laden der Seite — also meist
     über einem leeren Kasten weit unter der Falz. Jetzt erst, wenn das Bild
     wirklich geladen UND im Blick ist, plus eine Sekunde Puffer zum Ankommen. */
  (function(){
    var schon = gesehen('rrl2-hint-seen');
    var figuren = suchen('[data-rrl2-zoom]');
    if (!figuren.length) return;
    if (schon || ruhig || !('IntersectionObserver' in window)) {
      figuren.forEach(function(f){
        var h = f.querySelector('.rrl2-hint'); if (h) h.classList.add('is-done');
      });
      return;
    }
    var beobachter = new IntersectionObserver(function(einträge){
      einträge.forEach(function(e){
        if (!e.isIntersecting) return;
        var fig = e.target;
        var img = fig.querySelector('img');
        var hand = fig.querySelector('.rrl2-hint');
        /* Erst prüfen, DANN abmelden. Bis zum 31.07. stand disconnect() davor:
           die erste sichtbare Figur trennte den Beobachter und stieg dann hier
           aus, weil sie keine Hand hatte — es bekam also nie eine Figur eine.
           So läuft der Beobachter weiter, bis eine Figur mit Hand im Blick ist. */
        if (!hand) return;
        beobachter.disconnect();
        function starten(){ setTimeout(function(){ hand.classList.add('is-ready'); }, 1000); }
        if (!img || img.complete) starten();
        else img.addEventListener('load', starten, { once: true });
        /* die übrigen Figuren bekommen keine Hand mehr */
        figuren.forEach(function(f){
          if (f === fig) return;
          var h = f.querySelector('.rrl2-hint'); if (h) h.classList.add('is-done');
        });
      });
    }, { threshold: 0.5 });
    figuren.forEach(function(f){ beobachter.observe(f); });
  })();

  /* Kundenstimmen: zeigen, dass drei Geschichten dahinterstehen. Punktreihe
     plus Zähler, und beim ersten Sichtkontakt einmal kurz anstupsen. */
  (function(){
    var spur = eins('.rrl2-tm__t');
    if (!spur) return;
    var punkte = suchen('.rrl2-tm__p li');
    var nr = eins('[data-rrl2-nr]');
    var karten = spur.querySelectorAll('.rrl2-tm__c');
    if (!karten.length) return;
    var warte = 0;

    function malen(){
      warte = 0;
      var mitte = spur.scrollLeft + spur.clientWidth / 2;
      var beste = 0, kleinster = Infinity;
      for (var i = 0; i < karten.length; i++) {
        var k = karten[i];
        var km = k.offsetLeft + k.offsetWidth / 2;
        var d = Math.abs(km - mitte);
        if (d < kleinster) { kleinster = d; beste = i; }
      }
      for (var j = 0; j < punkte.length; j++) punkte[j].classList.toggle('is-on', j === beste);
      if (nr) nr.textContent = String(beste + 1);
    }
    spur.addEventListener('scroll', function(){
      if (!warte) warte = requestAnimationFrame(malen);
    }, { passive: true });
    malen();

    if (ruhig || gesehen('rrl2-stups-seen') || !('IntersectionObserver' in window)) return;
    var b = new IntersectionObserver(function(e){
      if (!e[0].isIntersecting) return;
      b.disconnect();
      setTimeout(function(){
        if (spur.scrollLeft > 4) return;          /* er wischt schon selbst */
        try {
          spur.scrollTo({ left: 34, behavior: 'smooth' });
          setTimeout(function(){ spur.scrollTo({ left: 0, behavior: 'smooth' }); }, 520);
        } catch (_) {}
      }, 700);
    }, { threshold: 0.4 });
    b.observe(spur);
  })();

  /* Buchwähler. Variant-IDs am 26.07.2026 an echten Warenkörben geprüft. */
  (function(){
    var host = eins('[data-rrl2-pick]');
    if (!host) return;
    /* Der Bahnname wird hier eigens geholt. Die Fassung vom 31.07. griff auf ein
       `bahn` aus einer anderen Kapsel zu — beim Abwählen von Karte B und bei jedem
       Druck auf die Klebeleiste flog ein ReferenceError, und die Messung feuerte
       nie. Am 31.07. in der Vorschau an der Konsole gesehen. */
    var bahn = root.dataset.rrl2Lane || 'unbekannt';
    /* Der Kaufbereich wird später ins Theme-Gerüst umgehängt und liegt dann
       AUSSERHALB von root — deshalb hier einmal die Knotenreferenz merken statt
       jedes Mal neu zu suchen. Die vorige Fassung nahm dafür document.querySelector:
       auf der Live-Seite richtig (es gibt nur einen Kaufbereich), in der Vorschau
       mit sechs Seiten aber schrieb jede Bahn in die Knöpfe der ERSTEN. Die
       Vorschau ist mein einziges Prüfmittel; sie muss stimmen. */
    var kaufbereich = eins('[data-rrl2-buy]');
    /* Die Cover liegen auf lp.getrootremedy.com. Fünf unter assets/covers/, das
       Stoffwechsel-Cover auf einem eigenen Pfad — am 30.07.2026 alle sechs mit
       HTTP 200 geprüft. Wer eines austauscht, prüft die Adresse einzeln nach;
       ein 404 hinterlässt hier ein leeres Kästchen mitten im Kaufweg. */
    var COVER = 'https://lp.getrootremedy.com/assets/';
    /* Daneben liegen unter assets/mini/ dieselben sechs Cover in 240×360 statt
       1000×1500 — gleiche Namen, gleiche Unterordner, am 03.08.2026 alle sechs mit
       HTTP 200 geprüft. Grund: die Kacheln im Wähler werden mit 66 CSS-Pixeln
       gezeichnet, also 198 Gerätepixeln bei dreifacher Dichte. Die große Datei
       wurde geladen und danach weggerechnet: 1 660 KB für fünf Daumennägel, jetzt
       157 KB. An der Stoffwechsel-Seite gemessen, kalter Cache, Slow 4G.
       Die Urdateien bleiben unter assets/ liegen, weil die alten Landingpages sie
       als Hauptcover in voller Größe brauchen. Wer hier etwas austauscht, legt
       beide Fassungen ab. */
    var MINI = COVER + 'mini/';
    var BOOKS = [
      { v:'54283869749532', n:'Stoffwechsel', c:'stoffwechsel/buch-cover.jpg' },
      { v:'54291387842844', n:'Schmerzen',    c:'covers/schmerzen-buch-cover.jpg' },
      { v:'54291387875612', n:'Verdauung',    c:'covers/verdauung-buch-cover.jpg' },
      { v:'54321797300508', n:'Schlaf',       c:'covers/schlaf-buch-cover.jpg' },
      { v:'54321797234972', n:'Nerven',       c:'covers/nerven-buch-cover.jpg' },
      { v:'54321797431580', n:'Stress',       c:'covers/stress-buch-cover.jpg' }
    ];
    /* Zwei Stufen, nicht sechs. Vorher lief hier eine Leiter bis 59,95 für sechs
       Werke. Sie ist raus, weil sie zwei Probleme hatte: ab drei Werken fraß der
       Staffelrabatt den Geschenk-Bxgy (siehe unten), und der Sprung von zwei auf
       drei nahm der Kundin vier Gratiswerke weg, ohne dass die Seite es sagte.
       Mit der Grenze bei zwei ist beides strukturell weg statt nachträglich
       geflickt. */
    var MAXWERKE = 2;
    /* Bezugspreis je Werk nach PAngV §11. 39,75 € war bis Mitte Juli 2026 der
       wirklich verlangte Preis, ohne Rabatt darauf — die Senkung auf 19,95 € kam
       danach. Deshalb darf er durchgestrichen werden. Wer diese Zahl anfasst,
       ändert vier Anzeigen auf einmal: Strich im Wähler, Strich im Kaufblock,
       Sparbetrag, und den Strich oben im Kaufbereich. */
    /* 39,75 € war bis Mitte Juli der Bezugspreis für den Zeitvergleich. Der ist am
       31.07. entfallen (PAngV §11), die Zahl lebt jetzt als Summe der Einzelpreise
       weiter. Konstante bleibt stehen, falls der Zeitvergleich je wieder belegbar wird. */
    var URSPRUNG = 39.75;
    var GESCHENKWERT = 19.80;   /* vier Werke à 4,95 €, am 31.07. in der Kasse abgelesen */
    var STUFEN = [null,
      {p:12.95,t:'Der Anfang'},{p:22.95,t:'Doppelt hält besser'}];
    var EUR = function(n){ return n.toFixed(2).replace('.', ',') + ' €'; };
    var TICK = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7.5 5.5 11 12 3.5"/></svg>';
    var fix = host.dataset.fix;
    /* Die vier Werke der Klosterbibliothek. Der Bxgy-Rabatt "Klosterbibliothek
       geschenkt" setzt sie auf 0 — aber nur, wenn sonst kein anderer
       automatischer Rabatt greift. Deshalb nur bei einem einzigen Werk. */
    var GESCHENKE = ['54048198361372','54048198394140','54048198459676','54151504494876'];

    /* Der Wähler: eine feste Zeile für das Werk dieser Seite, darunter die anderen
       fünf als Cover in EINER Reihe.

       Vorher standen hier sechs Zeilen mit Häkchen. An der Live-Seite gemessen
       (30.07.2026, 390 px): 458 px hoch. Diese Fassung braucht 206 px — an einer
       Prüfseite mit echtem CSS, Markup und Skript gemessen, nicht geschätzt. 252 px
       gespart, bei einer Seite von 10.874 px der größte Einzelgewinn an Länge, den
       sie ohne Inhaltsverlust hergibt.

       Warum Knöpfe und kein Auswahlfeld: ein Auswahlfeld kostet zwei Berührungen
       statt einer und zeigt die Cover erst nach dem Öffnen. Von 28 zerlegten
       Wettbewerberseiten benutzt keine ein Auswahlfeld für die Produktwahl; Thieme
       stellt drei Kacheln, GU zwei. Bei GU fehlt den Kacheln der ausgewählte
       Zustand — deshalb hier grüner Rahmen, grüne Beschriftung UND Häkchen.

       Kachelbreite kommt aus dem Raster: 390 px Fenster minus 2 × 16 px Rand minus
       4 × 7 px Lücke ergibt 66 px je Kachel — über den 48 px, ab denen Bildkacheln
       auf dem Handy zuverlässig getroffen werden. */
    var fest = null, andere = [];
    BOOKS.forEach(function(b){ if (b.v === fix) fest = b; else andere.push(b); });

    if (fest) {
      var zf = document.createElement('div');
      zf.className = 'rrw-fest';
      zf.innerHTML =
        '<img src="' + COVER + fest.c + '" alt="" width="38" height="52" loading="lazy">' +
        '<span class="rrw-fest__t">' + fest.n +
          '<span>diese Seite · 100 Anwendungen + 4 Helfer</span></span>' +
        '<span class="rrw-fest__p">12,95&nbsp;€<s>' + EUR(URSPRUNG) + '</s></span>';
      host.appendChild(zf);
    }

    var reihe = document.createElement('div');
    reihe.className = 'rrw-reihe';
    reihe.setAttribute('role', 'group');
    reihe.setAttribute('aria-label', 'Zweites Werk wählen, höchstens eines');
    andere.forEach(function(b){
      var k = document.createElement('button');
      k.type = 'button';
      k.className = 'rrw-k';
      k.dataset.v = b.v;
      k.dataset.n = b.n;
      k.setAttribute('aria-pressed', 'false');
      k.innerHTML =
        '<span class="rrw-k__h">' + TICK + '</span>' +
        '<img src="' + MINI + b.c + '" alt="" width="66" height="94" loading="lazy">' +
        '<b>' + b.n + '</b>';
      reihe.appendChild(k);
    });
    host.appendChild(reihe);

    var tier   = eins('[data-rrl2-tier]');
    var meta   = eins('[data-rrl2-meta]');
    var price  = eins('[data-rrl2-price]');
    var strike = eins('[data-rrl2-strike]');
    var cart   = eins('[data-rrl2-cart]');

    if (!tier || !meta || !price || !strike || !cart) return;   /* nichts halb aufbauen */

    /* Das Werk dieser Seite ist immer im Warenkorb, dazu höchstens EIN zweites.
       Damit braucht es keine Häkchenliste, keine Klickreihenfolge und keinen
       Deckel mehr — die Auswahl ist eine einzige Variable, und mehr als zwei Werke
       sind nicht darstellbar. Vorher stand hier eine Filterkette über sechs
       Kästchen plus ein Notausgang für den Fall, dass data-fix zu keinem Werk
       passte; beides ist mit dieser Form gegenstandslos. */
    var gewählt = null;                 /* Variant-ID des zweiten Werks, oder null */
    var leisteZeigen = null;            /* setzt die Klebeleiste, sobald sie da ist */

    function rechnen(){
      var n = gewählt ? 2 : 1;
      var st = STUFEN[n];
      tier.textContent = st.t;
      price.textContent = EUR(st.p);
      /* Zwei verschiedene Vergleiche, je nach Auswahl der belegbare:
         EIN Werk -> Preissenkung gegen den Bezugspreis. 39,75 € war bis Mitte Juli
         2026 real verlangt, die Senkung kam danach — das ist der Zeitvergleich,
         den PAngV §11 regelt, und er ist zulässig.
         ZWEI Werke -> Bündelvergleich gegen die Summe der HEUTIGEN Einzelpreise.
         Nicht gegen 2 × Bezugspreis: 79,50 € kann heute niemand mehr zahlen, das
         wäre derselbe unprüfbare Anker, den veda360, Apelian und medumio fahren.
         39,90 € ist jederzeit nachrechenbar, weil jedes Werk einzeln zu 19,95 €
         kaufbar bleibt. Fällt der Einzelverkauf weg, wird die Summe zum Mondpreis. */
      /* Bis zum 31.07. war der Vergleich bei EINEM Werk ein Zeitvergleich gegen
         39,75 € — den trägt PAngV §11 nicht: die Vorschrift verlangt den NIEDRIGSTEN
         Preis der letzten 30 Tage als Bezugsgröße, und das waren 19,95 €. Ein einzelner
         Tag zu 39,75 € genügt nicht (EuGH C-330/23, Aldi Süd, 2024: der Nachlass muss
         VON diesem Tiefstpreis aus gerechnet sein).
         Jetzt für beide Stufen dieselbe, nachrechenbare Grundlage: die Summe der Preise,
         die dieselben Werke heute einzeln kosten. Das Werk zu 19,95 € plus die vier
         Werke der Klosterbibliothek zu je 4,95 € — zusammen 39,75 €. Zufällig dieselbe
         Zahl wie vorher, aber eine, die jeder nachrechnen kann.
           1 Werk  = 1 × 19,95 + 19,80 = 39,75 €
           2 Werke = 2 × 19,95 + 19,80 = 59,70 €
         Fällt der Einzelverkauf eines Werks weg, wird die Summe zum Mondpreis. */
      var wort = 'Summe der Einzelpreise ';
      var voll = n * 19.95 + GESCHENKWERT;
      var spar = voll - st.p;
      if (spar > 0.001) {
        strike.hidden = false; strike.textContent = wort + EUR(voll);
        meta.innerHTML = (n === 1 ? '1 Werk' : n + ' Werke') +
          ' · du sparst <b>' + EUR(spar) + '</b>';
      } else {
        strike.hidden = true; meta.textContent = n === 1 ? '1 Werk' : n + ' Werke';
      }
      /* Die zwei Karten nach IM8-Vorbild. Sie ersetzen den alten Kaufblock
         .rrl2-sum, der bis zum 31.07. in der Seitenmitte stand. Die Rechnung
         darunter ist unverändert — nur die Anzeige ist eine andere. */
      var kA = eins('[data-rrl2-karte="2"]');
      var kB = eins('[data-rrl2-karte="1"]');
      if (kA && kB) {
        kA.classList.toggle('is-on', n === 2);
        kB.classList.toggle('is-on', n === 1);
      }
      var sparA = eins('[data-rrl2-spar2]');
      if (sparA) sparA.textContent = 'du sparst ' + EUR(2 * 19.95 + GESCHENKWERT - STUFEN[2].p);

      var teile = [fix + ':1'];
      if (gewählt) teile.push(gewählt + ':1');
      /* Die vier Geschenke gehen immer mit, weil der Wähler nie mehr als zwei
         Werke zulässt. Der Vergleich bleibt als Warnung stehen: Shopify wendet
         nur EINEN automatischen Rabatt an, und ab drei Werken gewann der früher
         hier laufende Staffelrabatt gegen den Geschenk-Bxgy. Am 27.07.2026 in der
         echten Kasse gemessen:
           1 Werk + Geschenke = 19,95 ✓   2 Werke + Geschenke = 29,95 ✓
           3 Werke + Geschenke = 59,55 statt 39,75 ✗
           6 Werke + Geschenke = 79,75 statt 59,95 ✗
         Die Bedingung bleibt trotz MAXWERKE = 2 stehen: wer die Grenze je wieder
         hochsetzt, läuft sonst ohne Warnung in genau diese Kasse. */
      if (n <= 2) teile = teile.concat(GESCHENKE.map(function(g){ return g + ':1'; }));
      cart.setAttribute('href', mitQuelle('/cart/' + teile.join(',')));

      /* Der Knopf oben im Kaufbereich zeigt dasselbe Ziel. Sonst setzt ein Klick
         dort die Auswahl stillschweigend auf ein Werk zurück — der Kunde zahlt
         weniger als er wollte und bekommt weniger als er angehakt hat. */
      var pplOben = kaufbereich && kaufbereich.querySelector('.rrl2-ppl');
      if (pplOben) pplOben.hidden = n !== 1;   /* CopeCart trägt nur ein Werk */

      if (leisteZeigen) leisteZeigen(n, EUR(st.p), mitQuelle('/cart/' + teile.join(',')));

      var oben = kaufbereich && kaufbereich.querySelector('.rrl2-cta--breit');
      if (oben) {
        oben.setAttribute('href', mitQuelle('/cart/' + teile.join(',')));
        /* Die Zahl gehört auf den Knopf. „· 2 Werke" ohne Preis zwingt die Kundin,
           nach oben zurückzuschauen, was das jetzt kostet — und der Preis ist der
           Grund, warum sie überhaupt zögert. 13 von 25 zerlegten Wettbewerberseiten
           zeigen den Preis im ersten Bildschirm; allergieratgeber schreibt ihn
           dreimal in die Knopfaufschrift und hat damit die schnellste Preisauskunft
           im ganzen Feld. Der Wert kommt aus demselben st.p derselben Runde, die
           auch den Warenkorb-Pfad baut — hartkodiert wäre er beim nächsten
           Preiswechsel still falsch. */
        oben.textContent = n > 1
          ? 'Sofort lesen · ' + n + ' Werke · ' + EUR(st.p)
          : 'Sofort lesen · ' + EUR(st.p);
      }

      /* Die Preisanzeige des alten oberen Kastens ([data-rrl2-oben-preis] und
         [data-rrl2-oben-strich]) ist mit dem Kasten am 31.07. weggefallen. Die
         beiden Zuweisungen liefen seitdem gegen null und sind hier entfernt —
         Code, der auf Markup zeigt, das es nicht gibt, liest sich beim nächsten
         Mal wie eine Anzeige, die kaputt ist. */
    }
    /* Eine Kachel an heißt: alle anderen aus. Ein zweiter Druck auf dieselbe
       Kachel wählt sie ab — sonst gäbe es keinen Weg zurück auf ein Werk, ohne
       die Seite neu zu laden. Kein Deckel nötig: mehr als eine Kachel kann nicht
       an sein. */
    var kacheln = [].slice.call(reihe.querySelectorAll('.rrw-k'));
    kacheln.forEach(function(k){
      k.addEventListener('click', function(){
        var schon = k.getAttribute('aria-pressed') === 'true';
        kacheln.forEach(function(o){ o.setAttribute('aria-pressed', 'false'); });
        if (schon) {
          gewählt = null;
        } else {
          k.setAttribute('aria-pressed', 'true');
          gewählt = k.dataset.v;
        }
        rechnen();
        /* Die Coverwahl war bis zum 31.07. das einzige Element im ganzen
           Kaufbereich, das gar nichts meldete — obwohl genau hier aus einem
           Werk zwei werden. Der Abwahlweg über Karte B wurde gezählt, der
           Hinweg nicht. Ab jetzt beides, und beides auch in D1.
           `titel` sagt, WELCHES zweite Werk gewählt wurde: daran sieht man,
           ob ein Beschwerdebild die anderen zieht. */
        var titel = (k.getAttribute('aria-label') || k.textContent || '').trim().slice(0, 40);
        if (schon) melde('pdp_werk_abgewaehlt', { lane: bahn, werke: 1 });
        else       melde('pdp_werk_gewaehlt',   { lane: bahn, werke: 2, titel: titel });
      });
    });

    /* Karte B abwählen heisst: kein zweites Werk. */
    var kB = eins('[data-rrl2-karte="1"]');
    if (kB) kB.addEventListener('click', function(){
      if (!gewählt) return;
      var an = reihe.querySelector('.rrw-k[aria-pressed="true"]');
      if (an) an.setAttribute('aria-pressed', 'false');
      gewählt = null;
      rechnen();
      /* Eigener Name seit dem 31.07. Vorher hiess das hier ebenfalls
         pdp_kasse_waehler — derselbe Name wie der ECHTE Kassenklick weiter
         unten. Jede Abwahl zählte damit als Kaufklick und blähte die Zahl auf.
         Der Kassenname bleibt unverändert, nur dieser hier wird eigenständig. */
      melde('pdp_werk_abgewaehlt', { lane: bahn, werke: 1 });
    });

    /* Karte A trägt Radio-Optik und das Band „Bester Preis", hatte aber keinen
       eigenen Klick: Antippen tat nichts, erst die Coverwahl schaltete um. Genau
       das hat er am 31.07. als kaputt gemeldet — der Preiswiderspruch war da
       schon behoben, die tote Optik nicht.
       Sie kann sich nicht selbst aktivieren: zwei Werke ohne zweites Werk gibt es
       nicht. Also dasselbe, was das Leisten-Menü in diesem Fall schon richtig tut
       — zum Wähler bringen und ihn zeigen.
       Klicks AUS dem Wähler heraus sind ausgenommen: er liegt in dieser Karte,
       und eine Coverwahl schaltet ohnehin selbst um. */
    var kA = eins('[data-rrl2-karte="2"]');
    if (kA) kA.addEventListener('click', function(e){
      if (gewählt) return;
      if (e.target.closest && e.target.closest('[data-rrl2-pick]')) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      (host || kA).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });

    /* Klebeleiste unten. Sie spiegelt nur, was rechnen() ohnehin ausrechnet —
       eigene Preislogik gäbe es zweimal und liefe irgendwann auseinander.
       Sie erscheint erst, wenn der breite Kaufknopf aus dem Blick ist. */
    var leiste = eins('[data-rrl2-leiste]');
    if (leiste) {
      var lAuf  = leiste.querySelector('[data-rrl2-leiste-auf]');
      var lMenu = leiste.querySelector('[data-rrl2-leiste-menu]');
      var lTit  = leiste.querySelector('[data-rrl2-leiste-t]');
      var lPre  = leiste.querySelector('[data-rrl2-leiste-p]');
      var lKauf = leiste.querySelector('[data-rrl2-leiste-kauf]');

      leisteZeigen = function(n, preis, ziel){
        lTit.textContent = n === 2 ? 'Zwei Werke' : 'Ein Werk';
        lPre.textContent = n === 2 ? preis + ' · du sparst ' + EUR(2 * 19.95 + GESCHENKWERT - STUFEN[2].p)
                                   : preis + ' · vier Zugaben dabei';
        lKauf.textContent = 'Sofort lesen · ' + preis;
        lKauf.setAttribute('href', ziel);
      };

      function menuZu(){ lMenu.hidden = true; lAuf.setAttribute('aria-expanded', 'false'); }
      lAuf.addEventListener('click', function(e){
        e.stopPropagation();
        var offen = !lMenu.hidden;
        lMenu.hidden = offen;
        lAuf.setAttribute('aria-expanded', offen ? 'false' : 'true');
      });
      document.addEventListener('click', function(e){
        if (!leiste.contains(e.target)) menuZu();
      });

      leiste.querySelectorAll('[data-rrl2-leiste-wahl]').forEach(function(b){
        b.addEventListener('click', function(){
          menuZu();
          var will = b.dataset.rrl2LeisteWahl === '2' ? 2 : 1;
          if (will === 1) {
            var an = reihe.querySelector('.rrw-k[aria-pressed="true"]');
            if (an) an.setAttribute('aria-pressed', 'false');
            gewählt = null;
            rechnen();
          } else if (!gewählt) {
            /* Zwei Werke ohne zweites Werk gibt es nicht. Statt still das
               nächstbeste zu nehmen: zum Wähler bringen und ihn zeigen. */
            var k = eins('[data-rrl2-karte="2"]');
            if (k) {
              var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              k.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            }
          }
          melde('pdp_leiste_wahl', { lane: bahn, werke: will });
        });
      });

      lKauf.addEventListener('click', function(){
        melde('pdp_kasse_leiste', { lane: bahn, werke: gewählt ? 2 : 1 });
      });

      /* Die Leiste steht durchgehend, vom Seitenanfang bis zum Ende — seine
         Entscheidung vom 31.07.
         Vorgeschichte, damit sie niemand aus Versehen zurückbaut: bis dahin
         erschien sie erst, wenn der breite Kaufknopf aus dem Blick war, damit
         nicht zwei Kaufknöpfe gleichzeitig dastehen. Das hing zuerst an einem
         IntersectionObserver (der bei Sprüngen ein veraltetes Rechteck lieferte
         und die Leiste ausliess), danach an einer Lageprüfung je Bild. Beides ist
         jetzt weg: keine Bedingung, kein Zuhörer am Scrollen, kein `hidden` im
         Markup. Er hat die zwei Kaufknöpfe oben ausdrücklich in Kauf genommen.
         Zurücknehmen: `hidden` ans div, und hier die Lageprüfung wieder einsetzen
         (steht im Verlauf der Datei vom 31.07., 05:05). */
    }

    /* Der Knopf unter der Bildstrecke öffnet die Folie „Was drinsteht" —
       IM8s „View Nutrition Label". Er löst denselben Klick aus wie die
       Kachel selbst, damit es nur EINEN Lichtbox-Weg gibt. */
    var auf = eins('[data-rrl2-inhalt-auf]');
    var inh = eins('[data-rrl2-inhalt]');
    var grossFig = eins('.rrw-gross');
    if (auf && inh) auf.addEventListener('click', function(){
      inh.click();                              /* die Folie nach vorn holen */
      if (grossFig) grossFig.click();           /* und vergrößern */
    });

    rechnen();
  })();

  /* Vorher/Nachher zum Ziehen. Drei Dinge machen es flüssig:
     das Rechteck wird einmal je Zug gelesen statt bei jeder Bewegung,
     geschrieben wird nur im nächsten Bild, und die Karussell-Spur wird
     stillgelegt, sobald die Geste als waagerecht erkannt ist — sonst reisst
     der Snap-Container das Ziehen an sich. Senkrechte Gesten werden
     durchgelassen, damit die Seite über dem Bild scrollbar bleibt. */
  suchen('.rrl2-ba').forEach(function(el){
    var spur = el.closest ? el.closest('.rrl2-tm__t') : null;
    var rect = null, ziel = null, warte = 0;
    var zieht = false, entschieden = false, sx = 0, sy = 0;

    function schreiben(){
      warte = 0;
      if (ziel === null) return;
      el.style.setProperty('--x', ziel + '%');
      el.setAttribute('aria-valuenow', Math.round(ziel));
    }
    function setzen(x){
      ziel = x < 0 ? 0 : x > 100 ? 100 : x;
      if (!warte) warte = requestAnimationFrame(schreiben);
    }
    function ausX(cx){
      if (!rect) rect = el.getBoundingClientRect();
      setzen((cx - rect.left) / rect.width * 100);
    }
    function spurAn(){ if (spur) { spur.style.scrollSnapType = 'none'; spur.style.overflowX = 'hidden'; } }
    function spurAus(){ if (spur) { spur.style.scrollSnapType = ''; spur.style.overflowX = ''; } }
    function los(){
      if (!zieht && !entschieden) return;
      zieht = false; entschieden = false; rect = null;
      el.classList.remove('is-zieht');
      spurAus();
    }

    el.addEventListener('pointerdown', function(e){
      zieht = true; sx = e.clientX; sy = e.clientY;
      rect = el.getBoundingClientRect();
      try { el.setPointerCapture(e.pointerId); } catch(_) {}
      if (e.pointerType === 'mouse') {
        entschieden = true;
        el.classList.add('is-zieht');
        spurAn();
        ausX(e.clientX);
        e.preventDefault();
      }
    });
    el.addEventListener('pointermove', function(e){
      if (!zieht) return;
      if (!entschieden) {
        var dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy);
        if (dx + dy < 6) return;              /* noch zu klein zum Deuten */
        if (dy > dx) { los(); return; }       /* senkrecht: Seite scrollen lassen */
        entschieden = true;
        el.classList.add('is-zieht');
        spurAn();
      }
      ausX(e.clientX);
      e.preventDefault();
    });
    el.addEventListener('pointerup', los);
    el.addEventListener('pointercancel', los);
    el.addEventListener('lostpointercapture', los);
    window.addEventListener('resize', function(){ rect = null; });

    el.addEventListener('keydown', function(e){
      var v = parseFloat(el.getAttribute('aria-valuenow')) || 52;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setzen(v - 5); e.preventDefault(); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setzen(v + 5); e.preventDefault(); }
      else if (e.key === 'Home') { setzen(0); e.preventDefault(); }
      else if (e.key === 'End') { setzen(100); e.preventDefault(); }
    });
  });

  /* Miniaturenreihe und Wischen. Beide Wege gehen durch dieselbe Funktion
     `zeigen(i)`, damit die aktive Kachel niemals etwas anderes markieren kann
     als das, was oben steht. Die Lichtbox liest die Quelle im Moment des Klicks,
     deshalb genügt der Tausch — es braucht keinen zweiten Weg zum Vergrößern. */
  (function(){
    var gross = eins('[data-rrl2-gross]');
    var unter = eins('[data-rrl2-gross-u]');
    var minis = [].slice.call(suchen('[data-rrl2-mini]'));
    if (!gross || !minis.length) return;
    var jetzt = Math.max(0, minis.indexOf(eins('[data-rrl2-mini].is-an')));

    function zeigen(i){
      if (i < 0 || i >= minis.length || i === jetzt) return false;
      var m = minis[i];
      jetzt = i;
      gross.src = m.dataset.quelle;
      gross.alt = m.dataset.alt || '';
      if (unter) unter.textContent = m.dataset.unter || '';
      minis.forEach(function(o){
        var an = o === m;
        o.classList.toggle('is-an', an);
        o.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      return true;
    }

    minis.forEach(function(m, i){ m.addEventListener('click', function(){ zeigen(i); }); });

    /* Wischen am großen Bild.

       Der senkrechte Bildlauf bleibt unangetastet, und zwar nicht über eine
       geratene Schwelle, sondern über `touch-action:pan-y` im Stilblock: der
       Browser erledigt das Scrollen weiterhin selbst und schickt uns nur die
       waagerechten Zeiger. Deshalb steht hier kein preventDefault. Fängt jemand
       senkrecht an, kommt pointercancel und wir sind sauber raus — die Seite
       kann beim Runterscrollen nicht hängen bleiben.

       Der Zuhörer hängt NUR am großen Bild. Die Vorher/Nachher-Schieber
       (.rrl2-ba) haben ihren eigenen pointermove; sie liegen in anderen
       Abschnitten und können sich mit diesem nicht gegenseitig fangen.

       Am Ende wird STEHENGEBLIEBEN, nicht umgelaufen: die Miniaturenreihe zeigt
       die absolute Lage an, ein Sprung von der fünften zurück auf die erste
       widerspräche dem, was darunter zu sehen ist. Eine Regel, in beide
       Richtungen dieselbe. */
    var fig = gross.closest('.rrw-gross');
    if (!fig || !window.PointerEvent) return;

    var x0 = 0, y0 = 0, zeiger = null, wischEnde = 0;

    fig.addEventListener('pointerdown', function(e){
      if (!e.isPrimary) return;
      zeiger = e.pointerId; x0 = e.clientX; y0 = e.clientY;
    });

    fig.addEventListener('pointerup', function(e){
      if (zeiger === null || e.pointerId !== zeiger) return;
      zeiger = null;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      /* 45 px, damit ein zitternder Finger beim Antippen keinen Wechsel auslöst;
         der Faktor 1,4 verlangt, dass waagerecht deutlich überwiegt. */
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      /* Die Zeit wird für JEDE erkannte Wischgeste gesetzt, auch für eine, die am
         Ende der Reihe ins Leere läuft. Sonst öffnete ein Zug über das letzte
         Bild hinaus die Lichtbox — die Geste war eindeutig ein Wischen, und ein
         Wischen zoomt nie. Gemeldet wird dagegen nur ein echter Wechsel. */
      wischEnde = Date.now();
      if (zeigen(jetzt + (dx < 0 ? 1 : -1))) {
        melde('bild_wisch', { lane: root.dataset.rrl2Lane || 'unbekannt',
                              richtung: dx < 0 ? 'weiter' : 'zurück' });
      }
    });

    fig.addEventListener('pointercancel', function(){ zeiger = null; });

    /* Mit der Maus startet ein Zug auf einem <img> das native Bild-Ziehen des
       Browsers. Das bricht die Zeigerfolge ab, es kommt nie ein pointerup, und
       der Wechsel bliebe aus. Am 31.07. mitgeschrieben:
         pointerdown → mousedown → dragstart → pointercancel → drag, drag, …
       Ein Finger löst kein natives Ziehen aus, am Telefon fiel es deshalb nicht
       auf. Kostet nur die Möglichkeit, das Bild auf den Schreibtisch zu ziehen —
       bei einem Galeriebild kein Verlust. */
    fig.addEventListener('dragstart', function(e){ e.preventDefault(); });

    /* Auf der Maus folgt einem Zug ein click auf dieselbe Fläche — ohne Sperre
       ginge dann jedes Mal die Lichtbox auf. Der Zuhörer sitzt in der
       Erfassungsphase am ELTERNKNOTEN: nur so läuft er sicher vor dem
       Lichtbox-Zuhörer, der am Bild selbst hängt. Am Bild selbst entschiede die
       Reihenfolge der Anmeldung, und die hinge an der Reihenfolge der Kapseln.

       Warum eine ZEIT und kein Merker: ein Wisch auf dem Telefon erzeugt gar
       keinen click. Ein Merker bliebe danach scharf und fräße den nächsten
       echten Klick — am 31.07. in der Rückfallprobe genau so passiert: nach
       einem Wisch öffnete „Sieh dir an, was drinsteht" nicht mehr, weil dessen
       Klick in die stehengebliebene Sperre lief. Ein Fenster von 350 ms trifft
       nur den Klick, den dieselbe Geste ausgelöst hat, und verfällt von selbst.

       Und `isTrusted`: der Knopf „Sieh dir an" ruft grossFig.click() selbst auf.
       Ein solcher Klick kommt vom Skript, nicht vom Finger — er darf NIE in die
       Sperre laufen, auch nicht, wenn er zufällig kurz nach einem Wisch kommt.
       Zeit allein reichte dafür nicht; die zwei Bedingungen zusammen schon. */
    var hülle = fig.parentNode;
    if (hülle) hülle.addEventListener('click', function(e){
      if (!e.isTrusted) return;                      /* vom Skript: durchlassen */
      if (Date.now() - wischEnde > 350) return;      /* zu spät: echter Tipp */
      wischEnde = 0;
      e.stopPropagation();
      e.preventDefault();
    }, true);
  })();

  /* Umami. Nur zählen, was eine Entscheidung zeigt — keine Mausbewegungen. */

  /* Welche Umami-Meldung zusätzlich nach D1 geht, und unter welchem Namen.
     Die Liste ist bewusst kurz: was hier NICHT steht, liegt in D1 bereits als
     `cta_click` mit einer Position — `pdp_kasse_oben`, `pdp_paypal`,
     `pdp_kasse_leiste` und `pdp_kasse_waehler` würden sonst doppelt zählen und
     die Kaufklick-Rate nach oben lügen.
     Die Namen tragen kein `pdp_`-Präfix, weil in D1 schon die Spalte `page`
     sagt, auf welcher Seite das Ereignis entstand. */
  var D1_NAME = {
    pdp_leiste_wahl:          'leiste_wahl',
    pdp_werk_gewaehlt:        'werk_dazu',
    pdp_werk_abgewaehlt:      'werk_ab',
    pdp_kapitel:              'kapitel_auf',
    pdp_aufklapper:           'aufklapper_auf',
    pdp_zurueck_zur_auswahl:  'zurueck_auswahl'
  };

  function melde(name, daten){
    try { if (window.umami && window.umami.track) window.umami.track(name, daten || {}); } catch(e) {}
    var d1 = D1_NAME[name];
    if (d1 && nachD1) nachD1(d1, daten || {});
  }
  (function(){
    var lane = root.dataset.rrl2Lane || 'unbekannt';

    /* Aus dem eigenen Kaufbereich heraus suchen, nicht aus dem Dokument: mit sechs
       Seiten in der Vorschau hängte sonst jede Bahn ihre Zähler an die Knöpfe der
       ERSTEN, und die Messnamen kämen mit der falschen Bahn zurück.
       Der gemerkte Knoten statt einer neuen Suche: an dieser Stelle ist der
       Bausatz schon umgezogen, `root.querySelector` gäbe hier null zurück und
       pdp_kasse_oben wie pdp_paypal bekämen nie einen Zuhörer. */
    var kaufbereich = bausatz;

    var oben = kaufbereich && kaufbereich.querySelector('.rrl2-cta--breit');
    if (oben) oben.addEventListener('click', function(){ melde('pdp_kasse_oben', { lane: lane }); });

    if (kaufbereich) kaufbereich.querySelectorAll('.rrl2-ppl').forEach(function(a){
      a.addEventListener('click', function(){ melde('pdp_paypal', { lane: lane }); });
    });

    var wk = eins('[data-rrl2-cart]');
    if (wk) wk.addEventListener('click', function(){
      /* Gezählt wird jetzt am neuen Wähler: das Werk dieser Seite ist immer
         dabei, dazu höchstens eine gedrückte Kachel. Vorher stand hier
         '.rrl2-pick__r.is-on' — diese Elemente gibt es seit dem 30.07. nicht mehr,
         die Zahl wäre stumm auf 0 gefallen. */
      var n = 1 + suchen('.rrw-k[aria-pressed="true"]').length;
      melde('pdp_kasse_waehler', { lane: lane, werke: n });
    });

    suchen('[data-rrl2-zoom]').forEach(function(f){
      f.addEventListener('click', function(){ melde('pdp_buchseite_gross', { lane: lane }); }, { once: true });
    });

    suchen('.rrl2-k').forEach(function(k){
      k.addEventListener('toggle', function(){
        if (k.open) melde('pdp_kapitel', { lane: lane, kapitel: (k.querySelector('b')||{}).textContent || '' });
      });
    });

    suchen('.rrl2-fold').forEach(function(f){
      f.addEventListener('toggle', function(){
        if (f.open) melde('pdp_aufklapper', { lane: lane, was: (f.querySelector('summary')||{}).textContent || '' });
      });
    });

    suchen('[data-rrl2-up]').forEach(function(a){
      /* ASCII, und das ist Absicht: Messnamen sind Maschinenkennungen, nicht
         Prosa — die eine Ausnahme der Umlautregel. Beim Umbau war daraus
         pdp_zurück_zur_auswahl geworden, was die Umami-Reihe in zwei Hälften
         spaltet. Zurück auf den Namen, unter dem die Historie liegt. */
      a.addEventListener('click', function(){ melde('pdp_zurueck_zur_auswahl', { lane: lane }); });
    });
  })();

  /* Die Kurzlinks bringen ?utm_source=manychat&... auf die Seite. /cart/... würde
     sie verlieren, dann käme die Bestellung ohne Quelle an. Also mitschleifen.

     Als Funktionsdeklaration, damit die Reihenfolge egal ist. Vorher stand hier
     ein sofort ausgeführtes "var UTM = (function(){...})()". rechnen() baut die
     Kauflinks aber weiter oben und lief damit gegen ein noch leeres UTM: an den
     /cart/-Link wurde "undefined" angehängt, und der Knopf führte in einen 404.
     Nur wer vorher die Menge umstellte, bekam einen heilen Link. */
  var UTM;
  function utmTeil(){
    if (UTM === undefined) {
      var q = new URLSearchParams(location.search), out = [];
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
        var v = q.get(k); if (!v) return;
        /* Shopify macht NUR aus attributes[...] echte note_attributes, und nur die
           liest der Worker in orders.utm_source. Der nackte Parameter ging an der
           Kasse verloren: alle 6 Bestellungen der Verkaufswoche 03.-06.08. standen
           als "direct", obwohl die Klaviyo-Links korrekt getaggt waren.
           Beide Formen, damit seitenseitiges Tracking unveraendert weiterlaeuft. */
        out.push('attributes[' + k + ']=' + encodeURIComponent(v));
        out.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
      UTM = out.length ? '?' + out.join('&') : '';
    }
    return UTM;
  }
  function mitQuelle(pfad){ return pfad + utmTeil(); }

  var lb = eins('.rrl2-lb');
  var lbImg = lb && lb.querySelector('img');
  if (!lb || !lbImg) return;

  var letzterAuslöser = null;
  suchen('[data-rrl2-zoom]').forEach(function(fig){
    var img = fig.querySelector('img');
    if (!img) return;
    fig.setAttribute('tabindex', '0');
    fig.setAttribute('role', 'button');
    fig.setAttribute('aria-label', 'Seite vergrößern');
    function open(){
      lb.dataset.rrlZurück = '1';
      letzterAuslöser = fig;
      /* src zuerst, nicht currentSrc. Die Miniaturen und der Wisch tauschen die
         Quelle des großen Bildes; currentSrc wird aber erst gesetzt, wenn der
         Browser die neue Quelle ausgewählt hat — das ist nicht synchron. Wer
         direkt nach dem Tausch vergrößert, bekäme sonst das VORHERIGE Bild.
         In dieser Datei kommt kein srcset vor (geprüft am 31.07., 0 Treffer),
         also ist src immer die richtige und die aktuelle Quelle. */
      lbImg.src = img.getAttribute('src') || img.currentSrc || img.src;
      lbImg.alt = img.alt;
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open','');
      var h = fig.querySelector('.rrl2-hint');
      if (h) h.classList.add('is-done');
    }
    fig.addEventListener('click', open);
    fig.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });

  suchen('[data-rrl2-up]').forEach(function(a){
    a.addEventListener('click', function(e){
      /* Seit dem 31.07. gibt es #rr-auswahl nicht mehr — der Abschnitt ist im
         Kaufbereich oben aufgegangen. Der Endknopf springt jetzt dorthin. */
      var z = document.getElementById('rr-kaufen');
      if (!z) return;                      /* kein Anker: normaler Sprung */
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      z.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  function close(){
    if (typeof lb.close === 'function') lb.close(); else lb.removeAttribute('open');
    if (letzterAuslöser) letzterAuslöser.focus();
  }
  lb.addEventListener('click', function(e){ if (e.target === lb || e.target === lbImg) close(); });
  var x = lb.querySelector('.rrl2-lb__x');
  if (x) x.addEventListener('click', close);

  /* Erst wenn alles ohne Fehler durchgelaufen ist. Sonst darf ein zweiter
     Durchlauf es nochmal versuchen. */
  root.dataset.rrl2Ready = '1';
})();

/* rr-aktion-sommer7 — Aktionswoche 03.–09.08.2026. NACH DEM 09.08. ERSATZLOS LÖSCHEN
   (alles zwischen dieser Zeile und "ende rr-aktion-sommer7").

   Wozu der Block da ist: der Aktionspreis steckt seit dem 03.08. im Shopify-Produkt
   selbst (12,95 statt 19,95). CopeCart weiß davon nichts — dort steht weiter 19,95,
   und der Nachlass kommt nur über den Parameter ?promocode= zustande. Ohne diese
   Zeilen zahlt jede Frau, die auf „Mit PayPal bezahlen" tippt, den vollen Preis,
   während alle anderen 12,95 zahlen. Still, ohne Fehlermeldung.

   Das discount= am Warenkorb-Link ist Vorsorge: SOMMER7 greift bei Shopify derzeit
   nicht, weil der Gutschein für die vier Zugaben den Platz belegt und zwei Codes
   derselben Klasse einander ausschließen. Am 03.08. nachgemessen — er schadet nicht,
   und er trägt, falls der Zugaben-Gutschein einmal wegfällt.

   Sobald die sechs CopeCart-Preise ebenfalls auf 12,95 stehen, ist dieser ganze
   Block überflüssig und gehört gelöscht. */
(function(){
  var CODE = 'SOMMER7';

  // Im Zugriff statt einmalig: die Kaufknöpfe werden neu geschrieben, sobald sie
  // ein zweites Werk wählt. Einmaliges Anhängen wäre danach wieder verschwunden.
  document.addEventListener('click', function(e){
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href*="/cart/"]');
    if (a) {
      var h = a.getAttribute('href') || '';
      if (h.indexOf('discount=') === -1) {
        a.setAttribute('href', h + (h.indexOf('?') > -1 ? '&' : '?') + 'discount=' + CODE);
      }
      return;
    }
    var p = e.target.closest('a.rrl2-ppl[href*="copecart.com"]');
    if (p) {
      var hp = p.getAttribute('href') || '';
      if (hp.indexOf('promocode=') === -1) {
        p.setAttribute('href', hp + (hp.indexOf('?') > -1 ? '&' : '?') + 'promocode=' + CODE);
      }
    }
  }, true);
})();
/* ende rr-aktion-sommer7 */
